export const getTripDisplayStops = (tripData) => {
  if (Array.isArray(tripData?.effective_stops) && tripData.effective_stops.length > 0) {
    return tripData.effective_stops;
  }

  return Array.isArray(tripData?.stops) ? tripData.stops : [];
};

export default getTripDisplayStops;
